/* eslint-disable react/destructuring-assignment */
// Copyright (c) 2016 Deere & Company

import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';

const TranslatedOption = (props) => (
    <FormattedMessage id={props.text}>
        {(formattedMessage) => (
            <option
                className="translated-option"
                value={props.value}
            >
                {formattedMessage}
            </option>
        )}
    </FormattedMessage>
);

TranslatedOption.displayName = 'TranslatedOption';
TranslatedOption.propTypes = {
    text: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
};

export default TranslatedOption;
